shadow$provide[111] = function(require,module,exports) {
var require$three = require("three");
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("renderer", {defaults:{klass:require$three.WebGL1Renderer, parameters:{depth:true, stencil:true, preserveDrawingBuffer:true, antialias:true,},}, listen:["resize"], install:function(three) {
  const renderer = three.renderer = new this.options.klass(this.options.parameters);
  three.canvas = renderer.domElement;
  three.element.appendChild(renderer.domElement);
}, uninstall:function(three) {
  three.element.removeChild(three.renderer.domElement);
  delete three.renderer;
  delete three.canvas;
}, resize:function(event, three) {
  const renderer = three.renderer;
  const el = renderer.domElement;
  if (el && el.tagName == "CANVAS") {
    renderer.setSize(event.renderWidth, event.renderHeight, false);
  } else {
    if (renderer.setRenderSize) {
      renderer.setRenderSize(event.renderWidth, event.renderHeight);
    }
    renderer.setSize(event.viewWidth, event.viewHeight, false);
  }
},});

};